function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.524 5.313a2.083 2.083 0 014.072-.875l2.117 9.852a.11.11 0 00.12.088.112.112 0 00.101-.113V2.085c0-1.151.932-2.085 2.08-2.085 1.15 0 2.082.934 2.082 2.086v12.213c0 .057.044.105.1.112a.11.11 0 00.121-.087l2.117-9.388a2.082 2.082 0 013.44-1.107c.551.502.794 1.26.637 1.99l-2.142 11.705c-.009.053.02.105.07.125.05.019.106 0 .136-.044l3.468-5.475a2.08 2.08 0 012.828-.632 2.09 2.09 0 01.723 2.812l-2.971 5.593a7.521 7.521 0 00-.882 3.541c0 4.694-1.31 8.554-6.242 8.556h-4.874a6.259 6.259 0 01-4.517-1.933l-7.301-9.735v-.014a2.091 2.091 0 01-.124-2.95 2.08 2.08 0 012.943-.124l3.918 3.428a.112.112 0 00.183-.1L7.524 5.312z",
  fill: "currentColor"
})));